import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "content"]
  
  connect() {
    this.active = false
    document.addEventListener('filter:close', this.close)
  }

  disconnect() {
    document.removeEventListener('filter:close', this.close)
  }

  open = () => {
    this.active = true
    this.containerTarget.classList.add("active")
    // set the height of the container target to the height of the content target
    this.element.style.height = (this.contentTarget.scrollHeight + 45 + 32) + "px"
    document.dispatchEvent(new CustomEvent('filter-item:open', { detail: { active: this.active } }))
  }

  close = () => {
    this.active = false
    this.containerTarget.classList.remove("active")
    this.element.style.height = "auto"
    document.dispatchEvent(new CustomEvent('filter-item:close', { detail: { active: this.active } }))
  }
}
